import { render, staticRenderFns } from "./onboarding-dashboard.page.vue?vue&type=template&id=149ef142&scoped=true&"
import script from "./onboarding-dashboard.page.vue?vue&type=script&lang=js&"
export * from "./onboarding-dashboard.page.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-dashboard.page.vue?vue&type=style&index=0&id=149ef142&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149ef142",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VCard,VExpansionPanels,VMenu,VOverlay})
